import React, { useState, useEffect } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import axiosInstance from '../utils/axiosInstance';
import '../styles/Pipeline.css';

const stages = ['New', 'Contacted', 'In Progress', 'Converted', 'Closed'];

function Pipeline() {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchLeads = async () => {
      try {
        const response = await axiosInstance.get('/leads');
        setLeads(response.data);
        console.log('Fetched leads:', response.data); // Log fetched leads
        setError('');
      } catch (err) {
        setError('Failed to load leads.');
        console.error('Error fetching leads:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchLeads();
  }, []);

  const onDragEnd = async (result) => {
    const { source, destination } = result;
    console.log('Drag result:', result); // Log drag result for debugging

    if (!destination) {
      console.log('Dropped outside a droppable area');
      return;
    }

    const draggedLead = leads.find((lead) => lead._id === result.draggableId);
    console.log('Dragged lead:', draggedLead); // Log dragged lead

    if (draggedLead && source.droppableId !== destination.droppableId) {
      try {
        console.log(`Updating lead status for ${draggedLead.name} from ${source.droppableId} to ${destination.droppableId}`);
        
        // Update the lead status in the backend
        await axiosInstance.patch(`/leads/${draggedLead._id}/status`, {
          status: destination.droppableId,
        });

        console.log(`Lead ${draggedLead.name} status updated to ${destination.droppableId}`);

        // Update the lead status in the frontend
        setLeads((prevLeads) =>
          prevLeads.map((lead) =>
            lead._id === draggedLead._id
              ? { ...lead, status: destination.droppableId }
              : lead
          )
        );
      } catch (err) {
        console.error('Failed to update lead status:', err);
      }
    }
  };

  if (loading) {
    return <div className="spinner">Loading...</div>;
  }

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  return (
    <div className="pipeline-container">
      <h1>Lead Pipeline</h1>
      <DragDropContext onDragEnd={onDragEnd}>
        <div className="pipeline-stages">
          {stages.map((stage) => (
            <Droppable droppableId={stage.toLowerCase()} key={stage}>
              {(provided) => (
                <div
                  className="pipeline-stage"
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                >
                  <h2>{stage}</h2>
                  {leads
                    .filter((lead) => lead.status === stage.toLowerCase())
                    .map((lead, index) => (
                      <Draggable
                        draggableId={lead._id.toString()}
                        index={index}
                        key={lead._id}
                      >
                        {(provided) => (
                          <div
                            className="lead-card"
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <p>
                              <strong>{lead.name}</strong>
                            </p>
                            <p>Loan Amount: ${lead.loanAmount}</p>
                            <p>Status: {lead.status}</p>
                          </div>
                        )}
                      </Draggable>
                    ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          ))}
        </div>
      </DragDropContext>
    </div>
  );
}

export default Pipeline;